// extracted by mini-css-extract-plugin
export default {"container":"poster-editor-color-panel-module__container--M9txd","gap":"poster-editor-color-panel-module__gap--qjMe7"};